(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["floating-cta-dodge"] && !Shopify.designMode) return;
  try {
    (() => {
  const PROTECTED = '.pm-pe__btn, .pm-pe__quick-btn, .car-product-page__actions a, .car-product-page__actions button, .pm-budget-cta__btn';
  const YIELD = 'pm-fab-yield';

  if (!window.matchMedia('(pointer: coarse)').matches) return;

  const fab = document.querySelector('.cta_group_preview');
  if (!fab) return;

  const targets = document.querySelectorAll(PROTECTED);
  if (!targets.length) return;

  // The FAB is position:fixed, so its viewport rect only changes on resize.
  // Cached because scale(0) collapses the live rect to 0x0 once it yields.
  let zone = null;
  const measure = () => {
    fab.classList.remove(YIELD);
    zone = fab.getBoundingClientRect();
  };

  let queued = false;

  // 8px of slack, so a CTA stopping just shy of the FAB doesn't hide it
  const overlaps = (a, b) =>
    a.left < b.right - 8 && a.right > b.left + 8 && a.top < b.bottom - 8 && a.bottom > b.top + 8;

  const update = () => {
    queued = false;
    if (!zone) return;

    let hit = false;
    for (const el of targets) {
      const r = el.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight) continue;
      if (overlaps(zone, r)) {
        hit = true;
        break;
      }
    }

    fab.classList.toggle(YIELD, hit);
  };

  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(update);
  };

  addEventListener('scroll', schedule, { passive: true });
  addEventListener('resize', () => {
    measure();
    schedule();
  }, { passive: true });

  measure();
  update();
})();
  } catch(e) { console.error(e); }
})();

})();
